import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import VehicleContextProvider from './components/Context/VehicleContext';
import UserContextProvider from './components/Context/UserContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(   
  <UserContextProvider>
    <VehicleContextProvider>
      <App />
    </VehicleContextProvider>
  </UserContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
